export enum SubscriptionStatus {
    TRIAL = 'Trial',
    PAYMENT_OVERDUE = 'Payment Overdue',
    BASIC = 'Basic',
    BUSINESS = 'Business',
    ENTERPRISE = 'Enterprise',
}
